<template>
    <div class="pricing-area bg-gradient-color">
        <div class="container">
            <div class="pricing-tabs">
                <div class="row align-items-center">
                    <div class="col-lg-4 col-md-12">
                        <div class="pricing-section-title">
                            <span class="sub-title text-uppercase">Pricing Plan</span>
                            <h2>Your Plan, Your Way</h2>
                            <div class="tabs">
                                <ul class="tabs__header">
                                    <li 
                                        class="tabs__header-item" 
                                        v-for="tab in tabs" 
                                        v-on:click="selectTab (tab.id)" 
                                        v-bind:class="{ 'active': activeTab == tab.id }"
                                        :key="tab.id"
                                    >
                                        {{tab.title}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-12">
                        <div class="tab-content">
                            <div class="tabs__container">
                                <div 
                                    class="tabs__list"
                                    ref='tabsList'
                                >
                                    <div 
                                        class="tabs__list-tab"
                                        v-for="tab in tabs"
                                        v-bind:class="{ 'active': activeTab == tab.id }"
                                        :key="tab.id"
                                    >
                                        <div class="row justify-content-center">
                                            <div 
                                                v-for="pricing in tab.pricingBox"
                                                :key="pricing.id"
                                                :class="tab.compare ? 'col-lg-6 col-md-6 col-sm-6' : 'col-lg-12 col-md-12 col-sm-12'"
                                            >
                                                <div class="single-pricing-table">
                                                    <div class="title">
                                                        <h3>{{pricing.title}}</h3>
                                                        <p>{{pricing.desc}}</p>
                                                    </div>
                                                  
                                             
                                                    <a v-if="pricing.cta_link.startsWith('http')" 
                                                       :href="pricing.cta_link" 
                                                       target="_blank" 
                                                       rel="noopener noreferrer" 
                                                       class="default-btn">
                                                        {{pricing.cta_btn}}
                                                    </a>
                                                    <router-link v-else :to="pricing.cta_link" class="default-btn">
                                                        {{pricing.cta_btn}}
                                                    </router-link>
                                                     
                                                    <ul class="features-list">
                                                        <li
                                                            v-for="features in pricing.featuresList"
                                                            :key="features.id"
                                                        >
                                                            <i :class="features.icon"></i> 
                                                            {{features.list}}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="shape7"><img src="../../assets/images/shape/shape6.png" alt="shape" loading="eager" /></div>
        <div class="shape8"><img src="../../assets/images/shape/shape7.png" alt="shape" loading="eager" /></div>
    </div>
</template>

<script>
export default {
    name: 'Pricing',
    props: {
        pricingPlan: {
            type: Array,
            default: null
        }
    },
    data () {
        return {
            activeTab: 1,
            offsetRight: 0,
            defaultTabs: [
                {
                    id: 1,
                    title: 'Custom',
                    pricingBox: [
                        {
                            id: 1,
                            title: 'Our Development Services ',
                            price: '49',
                            period: 'Custom Plan',
                            featuresList: [
                                { id: 1, icon: 'ri-check-line', list: 'User-Centric Design' },
                                { id: 2, icon: 'ri-check-line', list: 'Advanced Search' },
                                { id: 3, icon: 'ri-check-line', list: 'Loyalty Program Integration' },
                                { id: 4, icon: 'ri-check-line', list: 'Recommendation Engine ' },
                                { id: 5, icon: 'ri-check-line', list: 'Customization ' },
                                { id: 6, icon: 'ri-check-line', list: '24/7 Customer Support ' },
                            ],
                        },
                        {
                            id: 2,
                            title: 'Competitiors',
                            price: '69',
                            period: 'Custom plan',
                            featuresList: [
                                { id: 1, icon: 'ri-close-line', list: 'User-Centric Design ' },
                                { id: 2, icon: 'ri-check-line', list: 'Advanced Search' },
                                { id: 3, icon: 'ri-close-line', list: 'Loyalty Program Integration' },
                                { id: 4, icon: 'ri-close-line', list: 'Recommendation Engine' },
                                { id: 5, icon: 'ri-close-line', list: 'Customization' },
                                { id: 6, icon: 'ri-check-line', list: '24/7 Customer Support' },
                            ],
                        },
                    ],
                    compare: true
                },
                {
                    id: 2,
                    title: 'Subscription',
                    pricingBox: [
                        {
                            id: 1,
                            title: 'Our Development Services ',
                            price: '69',
                            period: 'Subscripition Plan',
                            featuresList: [
                                { id: 1, icon: 'ri-check-line', list: 'SEO Optimization' },
                                { id: 2, icon: 'ri-check-line', list: 'Maintenance' },
                                { id: 3, icon: 'ri-check-line', list: '24/7 Support' },
                                { id: 4, icon: 'ri-check-line', list: 'Marketing Package  ' },
                                { id: 5, icon: 'ri-check-line', list: 'Monthly Subscription Packaging  ' },
                            ],
                        },
                        {
                            id: 2,
                            title: 'Competitors',
                            price: '89',
                            period: 'Subscripition Plan',
                            featuresList: [
                                { id: 1, icon: 'ri-close-line', list: 'SEO Optimization' },
                                { id: 2, icon: 'ri-close-line', list: 'Maintenance' },
                                { id: 3, icon: 'ri-check-line', list: '24/7 Support' },
                                { id: 4, icon: 'ri-close-line', list: 'Marketing Package' },
                                { id: 5, icon: 'ri-close-line', list: 'Monthly Subscription Packaging' },
                            ],
                        },
                    ],
                    compare: true
                },
            ]
        }
    },
    computed: {
        tabs() {
            if (this.pricingPlan && Array.isArray(this.pricingPlan) && this.pricingPlan.length > 0) {
                return this.pricingPlan.map((plan, idx) => {
                    // If compare is false, only show the first section as a single pricing box
                    const compare = plan.compare !== false; // default true if not set
                    let pricingBox;
                    if (compare) {
                        pricingBox = plan.sections.map((section, sidx) => ({
                            id: sidx + 1,
                            title: section.title || section.label || `Section ${sidx + 1}`,
                            desc: section.summary || section.one_liner || '',
                            cta_btn: section.cta_btn || 'Explore',
                            cta_link: section.cta_link || '/contact',
                            featuresList: section.features.map((feature, fidx) => ({
                                id: fidx + 1,
                                icon: feature.highlight ? 'ri-check-double-line' : (feature.available ? 'ri-check-line' : 'ri-close-line'),
                                list: feature.name + (feature.description ? `: ${feature.description}` : ''),
                            }))
                        }));
                    } else {
                        // Only first section as single pricing box
                        pricingBox = plan.sections.length > 0 ? [
                            {
                                id: 1,
                                title: plan.sections[0].title || plan.sections[0].label || 'Plan',
                                desc: plan.sections[0].summary || plan.sections[0].one_liner || '',
                                cta_btn: plan.sections[0].cta_btn || 'Explore',
                                cta_link: plan.sections[0].cta_link || '/contact',
                                    featuresList: plan.sections[0].features.map((feature, fidx) => ({
                                    id: fidx + 1,
                                    icon: feature.highlight ? 'ri-check-double-line' : (feature.available ? 'ri-check-line' : 'ri-close-line'),
                                    list: feature.name + (feature.description ? `: ${feature.description}` : ''),
                                }))
                            }
                        ] : [];
                    }
                    return {
                        id: idx + 1,
                        title: plan.plan_type || `Plan ${idx + 1}`,
                        pricingBox,
                        compare
                    };
                });
            }
            // Fallback to default static data
            return this.defaultTabs;
        }
    },
    methods: {
        selectTab (id) {
            let tabsList = this.$refs.tabsList
            this.activeTab = id
            this.offsetRight = tabsList.clientWidth * (id - 1)
            tabsList.style.right = this.offsetRight + 'px'
        }
    },
    mounted () {
        let tabsList = this.$refs.tabsList
        tabsList.style.right = this.offsetRight + 'px'
    }
}
</script>